<ng-template #sessiontimeout let-modal>
  <div class="p-2">
    <div class="mb-2">
      <div class="d-inline-block"><h5>Session due to expire</h5></div>
      <div class="d-inline-block float-end">
        <button (click)="extendSession()" aria-label="Close" class="close cross-btn" type="button">
          <ui-icon
            [color]="'dark-sky'"
            [name]="'interface-close-medium'"
            [size]="'24'"
            class="ml-1"
          ></ui-icon>
        </button>
      </div>
    </div>
    <div class="html-body">
      <div class="d-flex justify-content-between content-row">
        <img src="../../../../assets/images/Zeb3_VOYAGE_2x.png" alt="Voyage card image" title="Voyage" />
        <div class="text-max-width">
          <p class="lead">You session is due to expire in <strong>{{countdown}} seconds.</strong></p>
          <p>Click 'Extend session' to continue with your application.</p>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <!-- <ui-button [btnClass]="'secondary'"
                (click)="modal.close('close')"         
                [block]="true">
        Don't extend session
      </ui-button>  -->
      <ui-button [btnClass]="'primary'"
                (click)="extendSession()"         
                [block]="true">
        Extend session
      </ui-button>
    </div>
  </div>
</ng-template>
